import Big from "big.js"
import { useState } from "react"
import { usePerpConnectedEffect } from "sdk-react/perpetualProtocol/usePerpConnectedEffect"

import { PositionOpen } from "./usePositionOpen"

/**
 * NOTE: estimate future position's value (excluding funding fee / realized PnL)
 * DOC: https://www.notion.so/perp/Estimate-impacts-to-margin-ratio-during-open-position-5b9d0ce61dc3422c95b00b27e9f35624
 */
export function usePositionDraftDetail() {
    const { buyingPower, priceImpact, entryPrice, transactionFee, error } = PositionOpen.useContainer()

    // NOTE: Get mmRatio & imRatio
    const [mmRatio, setMMratio] = useState<Big>()

    usePerpConnectedEffect(({ clearingHouseConfig }) => {
        setMMratio(clearingHouseConfig.mmRatio)
    }, [])

    return {
        buyingPower,
        mmRatio,
        entryPrice,
        priceImpact,
        transactionFee,
        error,
    }
}
